import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import React, { useCallback, useContext } from 'react';
import UIButton from 'UIComponents/button/UIButton';
import { getAppShortlink } from 'ecosystem-marketplace-core/assets/utils/urls';
import ThemeDetailsUsageTrackerContext from '../../context/ThemeDetailsUsageTrackerContext';

function ThemeSignInButton(_ref) {
  let {
    onClick,
    section,
    slug
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["onClick", "section", "slug"]);

  const {
    trackBeforeUnloadInteraction
  } = useContext(ThemeDetailsUsageTrackerContext);
  const detailsPageShortLink = getAppShortlink({
    pathname: `/${slug}`,
    theme: slug
  });
  const handleClick = useCallback(evt => {
    trackBeforeUnloadInteraction('click sign in cta button', {
      section
    });
    if (onClick) onClick(evt);
  }, [onClick, section, trackBeforeUnloadInteraction]);
  return /*#__PURE__*/_jsx(UIButton, Object.assign({}, rest, {
    href: detailsPageShortLink,
    onClick: handleClick,
    use: "primary",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplace-assets-ui.themes.details.signInButton"
    })
  }));
}

export default ThemeSignInButton;